import React from 'react'
import GlitchClip from 'react-glitch-effect/core/GlitchClip';

import Panel from '../components/Panel.js'
import Statement from '../components/Statement.js'
import { panelColors } from '../data/themes.js'
import FullscreenVideo from '../components/FullscreenVideo.js'

export default () =>
  <Panel fullscreen theme={panelColors.intro}>
    <FullscreenVideo src="blurred-leaves.mp4"/>
    <Statement title="Why are you here?">
      <GlitchClip>
        <h3>No, really. Why are you here?</h3>
        <p>Are you here to learn about me? Or are you here to learn about yourself?</p>
      </GlitchClip>
    </Statement>
  </Panel>
